/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Cta_TitleInputs */

const en_svc_research_cta_title = /** @type {(inputs: Svc_Research_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring the question you keep researching by hand.`)
};

const lv_svc_research_cta_title = /** @type {(inputs: Svc_Research_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet jautājumu, ko joprojām pētāt ar roku.`)
};

/**
* | output |
* | --- |
* | "Bring the question you keep researching by hand." |
*
* @param {Svc_Research_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_cta_title = /** @type {((inputs?: Svc_Research_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_cta_title(inputs)
	return en_svc_research_cta_title(inputs)
});